// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

const Cart: React.FunctionComponent<any> = ({ fillInBasket, ...props }) => {
    return (
        <SvgIcon width="24" height="24" viewBox="0 0 24 23" {...props}>
            <circle cx="9" cy="21" r="2" fillRule="nonzero" />
            <circle cx="20" cy="21" r="2" fillRule="nonzero" />
            {!fillInBasket && (
                <path
                    fillRule="nonzero"
                    d="M9.6 17c-1.4 0-2.6-1-2.9-2.4L5 6.2v-.1L4.2 2H1c-.6 0-1-.4-1-1s.4-1 1-1h4c.5 0 .9.3 1 .8L6.8 5H23c.3 0 .6.1.8.4.2.2.2.5.2.8l-1.6 8.4c-.3 1.4-1.6 2.4-3 2.4H9.6c.1 0 0 0 0 0zM7.2 7l1.4 7.2c.1.5.5.8 1 .8h9.7c.5 0 .9-.3 1-.8L21.8 7H7.2z"
                />
            )}
            {fillInBasket && (
                <path
                    fillRule="nonzero"
                    d="M9.6 17c-1.4 0-2.6-1-2.9-2.4L5 6.2v-.1L4.2 2H1c-.6 0-1-.4-1-1s.4-1 1-1h4c.5 0 .9.3 1 .8L6.8 5H23c.3 0 .6.1.8.4.2.2.2.5.2.8l-1.6 8.4c-.3 1.4-1.6 2.4-3 2.4H9.6c.1 0 0 0 0 0z"
                />
            )}
        </SvgIcon>
    );
};

export default Cart;
